
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.776 19.938H3.167A3.17 3.17 0 010 16.77V3.167A3.17 3.17 0 013.167 0h24.61a3.17 3.17 0 013.167 3.167V16.77a3.17 3.17 0 01-3.168 3.168zM3.167 1.084A2.088 2.088 0 001.081 3.17v13.603a2.088 2.088 0 002.086 2.086h24.61a2.09 2.09 0 002.085-2.086V3.167a2.089 2.089 0 00-2.086-2.086l-24.609.003z"}}),_c('path',{attrs:{"d":"M16.614 17.576h-1.081v-5.733a1.076 1.076 0 00-1.075-1.075H6.58a1.076 1.076 0 00-1.075 1.075v3.168H4.425v-3.168A2.159 2.159 0 016.58 9.687h7.877a2.159 2.159 0 012.156 2.156v5.733zM10.52 8.739a2.917 2.917 0 110-5.834 2.917 2.917 0 010 5.834zm0-4.751a1.834 1.834 0 100 3.669 1.834 1.834 0 000-3.67zM26.385 4.683h-7.887v1.08h7.887v-1.08zM26.385 7.533h-7.887v1.081h7.887v-1.08z"}})])
          )
        }
      }
    